import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import { Link } from "react-router-dom";
import {API_GET, API_POST} from "../../services/api.service";
import _ from "underscore";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import Filters from "./Filter";
import Button from "components/CustomButtons/Button.jsx";


import Highcharts from 'highcharts';
import drilldown from 'highcharts/modules/drilldown.js';
import HighchartsReact from 'highcharts-react-official';
import CustomTabs from "../../components/CustomTabs/CustomTabs";
import ErrorBoundary from "../../hoc/ErrorBoundary";
import Followups from "../Schedule/Followups";
import Appointment from "../Schedule/Appointment";
import DispositionDetails from "./DispositionDetails";
import ReportsStats from "../ReportStats/reportsStats";
import InfoIcon from "@material-ui/icons/Info";
import Typography from "@material-ui/core/Typography";
import InfoBox from "../../components/InfoIcon/InfoIcon";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import { Snackbar, IconButton } from "@material-ui/core";
import { getCookie, maskNumber } from "../../services/Common";


//import _ from "underscore";

const filterquery={ $and: [ { $or: [{ IsActive: { $exists: false } }, { IsActive: true }] }   ]};
let mysq={};


const chartOption={
  "title": {
    "text": "WorkLoad"
  },
  "tooltip": {
    "pointFormat": "<span style=\"color:{point.color};\">{series.name}</span>: <b>{point.y}</b>",
    "backgroundColor": "white"
  },
  "chart": {
    "type": "pie",
  },
  "plotOptions": {
    "series": {
      "cursor": "pointer",
      "dataLabels": {
        "color": "#428bca",
        "distance": -30,
        "enabled": true,
        "backgroundColor": "white",
        "format": "{point.percentage:.1f}%"
      },
      "showInLegend": true,
      "allowPointSelect": true
    }
  },
  "series": [
    {
      "name": "Workload",
      "id": "Workload",
      "colorByPoint": true,
      "data": null
    }
  ]
};

function Workload(props) {
  const { user } = props;
  const [data, setData] = useState([]);
  const [disposition, setDisposition] = useState([]);
  let dispositionColumnDone = 0;

  const [favoriteProspects, setFavoriteProspects] = useState([]);
  const [favoriteLoading, setFavoriteLoading] = useState(false);
  const [favoriteQuery, setFavoriteQuery] = useState({});
  const [enableFavoriteProspects, setEnableFavoriteProspects] = useState(false);
  const [favoriteDynamicFields, setFavoriteDynamicFields] = useState([]);
  const [notify, setNotify] = useState({
    open: false,
    message: null,
    color: "success",
  });

  const loadFavoriteSettings = async () => {
    try {
      const cookieSettings = getCookie('confSettings');
      if (cookieSettings) {
        const parsed = typeof cookieSettings === 'string' ? JSON.parse(cookieSettings) : cookieSettings;
        if (parsed && parsed.enableFavoriteProspects !== undefined) {
          setEnableFavoriteProspects(parsed.enableFavoriteProspects === true);
          return;
        }
      }
      if (user && user.admin) {
        let registerRequest = await API_POST("action/getdata", {
          root: "Configuration",
          con: { configName: "basic", admin: user && user.admin },
          cols: {},
        });
        if (
          registerRequest &&
          registerRequest.status == 200 &&
          registerRequest.data &&
          registerRequest.data.length > 0
        ) {
          setEnableFavoriteProspects(registerRequest.data[0].enableFavoriteProspects === true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFavoriteURL = () => {
    window.localStorage.setItem("LastURL", window.location.href);
  };

  const loadFavoriteProspects = async () => {
    if (!user || !user.admin) return;
    setFavoriteLoading(true);
    try {
      // --- Load dynamic column fields for Favorite Prospects (mirrors Activity.jsx pattern) ---
      try {
        const prospect_res = await API_POST("action/getdata", {
          root: "prospect_fields",
          con: { admin: user && user.admin, inFavoriteReport: true },
        });
        if (prospect_res && prospect_res.data && prospect_res.data.length > 0) {
          setFavoriteDynamicFields(prospect_res.data);
        } else {
          setFavoriteDynamicFields([]);
        }
      } catch (fieldErr) {
        console.warn("Could not load favorite report prospect_fields:", fieldErr);
        setFavoriteDynamicFields([]);
      }

      let con = {
        admin: user && user.admin,
        IsActive: true,
        favorite: true
      };
      if (user && ["field_exc", "agent"].indexOf(user.role) > -1) {
        con = { ...con, assignTo: user && user.username };
      }
      setFavoriteQuery(con);
      let registerRequest = await API_POST("action/getPaginationData", {
        root: "prospects",
        querydata: con,
        body: {
          limit: 1000,
          skip: 0,
          sort: { createdOn: -1 }
        },
      });
      if (registerRequest && registerRequest.status == 200) {
        setFavoriteProspects(registerRequest.data.activityData || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setFavoriteLoading(false);
    }
  };

  const handleExportFavoriteProspects = async () => {
    try {
      let downloadFile = await API_POST(`action/ExportExcel`, {
        querydata: favoriteQuery,
        body: { admin: user.admin, user: user.username, page: "prospects" },
      });
      if (downloadFile.status == 200) {
        setNotify({
          open: true,
          message: "File is in process,Please check in system log section.",
          color: "success",
        });
      }
    } catch (error) {
      console.log(error);
      setNotify({
        open: true,
        message: "Failed to export data.",
        color: "danger",
      });
    }
  };

  // Always-present default columns (per user requirement: Phone, Name, Disposition, Last Called, Followup, Remark)
  const favoriteProspectsDefaultColumns = [
    {
      name: "Phone",
      cell: (row) => {
        let campaignIsActive = row.CampainData && row.CampainData.length > 0 ? row.CampainData[0].IsActive : true;
        let phoneVal = row.phone;
        if (
          row.CampainData &&
          row.CampainData.length > 0 &&
          row.CampainData[0].phoneNumberMasking
        ) {
          phoneVal = maskNumber(row.phone);
        }
        return (
          <Link onClick={handleFavoriteURL} to={"/admin/ViewProspect/" + row._id + "/1"}>
            {phoneVal}
          </Link>
        );
      },
    },
    {
      name: "Name",
      cell: (row) => {
        let name = "";
        if (row.firstName && row.lastName) {
          name = row.firstName + " " + row.lastName;
        } else if (row.firstName && row.firstName != ' ') {
          name = row.firstName;
        } else {
          if (
            row.CampainData &&
            row.CampainData.length > 0 &&
            row.CampainData[0].phoneNumberMasking
          ) {
            name = maskNumber(row.phone);
          } else {
            name = row.phone;
          }
        }
        return (
          <Link onClick={handleFavoriteURL} to={"/admin/ViewProspect/" + row._id + "/1"}>
            {name}
          </Link>
        );
      },
    },
    {
      name: "Disposition",
      width: "150px",
      cell: (row) => {
        let arr = [];
        if (row.dispositionArray && row.dispositionArray.length > 0) {
          for (
            let index = 0;
            index < row.dispositionArray.length;
            index++
          ) {
            const element = row.dispositionArray[index];
            arr.push(element.disposition_value);
          }
        }
        return arr.join(" > ");
      },
    },
    {
      name: "Last Called",
      cell: (row) => (
        <span>
          {row.LastCalled &&
            new Date(row.LastCalled).toLocaleString()}
        </span>
      ),
    },
    {
      name: "Followup Date",
      cell: (row) => (
        <span>
          {row.callback &&
            new Date(row.callback).toLocaleString()}
        </span>
      ),
    },
    {
      name: "Remark",
      cell: (row) => <span style={{ wordWrap: "break-word", width: "100%" }}>{row.remarks || "-"}</span>,
    },
  ];

  // Build final columns: defaults (always) + dynamic columns from prospect_fields where inFavoriteReport=true
  // Follows exact Activity.jsx pattern (see Activity.jsx lines 262-283)
  const favoriteProspectsColumns = (() => {
    const cols = [...favoriteProspectsDefaultColumns];
    if (favoriteDynamicFields && favoriteDynamicFields.length > 0) {
      for (let index = 0; index < favoriteDynamicFields.length; index++) {
        const fieldCfg = favoriteDynamicFields[index];
        // Skip if a default column already has this exact display name (avoid duplicates)
        const exists = cols.find(v => v.name === fieldCfg.display_Name);
        if (!exists && fieldCfg.display_Name && fieldCfg.field_name) {
          cols.push({
            name: fieldCfg.display_Name,
            selector: fieldCfg.field_name,
            cell: (row) => {
              const val = row[fieldCfg.field_name];
              if (val === undefined || val === null || val === "") return "-";
              // Handle array or object gracefully
              if (typeof val === "object") return Array.isArray(val) ? val.join(", ") : JSON.stringify(val);
              return String(val);
            },
          });
        }
      }
    }
    return cols;
  })();


  const loadWorkloadData = async () => {
    

    let res = await API_GET("action/AggregateReport", null, {
      admin: user && user.admin
    });

    let data=res.data;




    setData(data || []);

    

    //setChartOption(_chartOption);
  };

  const columns = [
    {
      name: "User",
     // selector: "username",
      width:'220px',
      cell: (row) => (
        <span>{row.username}</span>
      ),
    },

    {
      name: "Assigned Prospects",
      selector: "assigned",
      cell: (row) => (
          <>
          {
            row.username !='Total' ? (
                <Link to={'/admin/ListProspects?query='+btoa(JSON.stringify({ $and: [ { $or: [{ IsActive: { $exists: false } }, { IsActive: true }] },{assignTo:row.username}   ]}))}>
                  {row.assigned}</Link>
            ) : row.assigned
          }
          </>
      ),
    },

    {
      name: "Attempted",
      selector: "attempt",
      cell: (row) => (
          <>
            {
              row.username !='Total' ? (
                  <Link to={'/admin/ListProspects?query='+btoa(JSON.stringify({ $and: [ { $or: [{ IsActive: { $exists: false } }, { IsActive: true }] },{assignTo:row.username}   ],disposition: { $ne: null } }))}>
                    {row.attempt}</Link>
              ) : row.attempt
            }
          </>
      ),
    },
    {
      name: "Not Attempted",
      selector: "notAttempt",
      cell: (row) => (
          <>
            {
              row.username !='Total' ? (
                  <Link to={'/admin/ListProspects?query='+btoa(JSON.stringify({ $and: [ { $or: [{ IsActive: { $exists: false } }, { IsActive: true }] },{assignTo:row.username}   ],$or: [{ disposition: { $exists: false } }, { disposition: null }] }))}>
                    {row.notAttempt}</Link>
              ) : row.notAttempt
            }
          </>
      ),
    },

    {
      name: "Open",
      selector: "open",
      cell: (row) => (
          <>
            {
              row.username !='Total' ? (
                  <Link to={'/admin/ListProspects?query='+btoa(JSON.stringify({ $and: [ { $or: [{ IsActive: { $exists: false } }, { IsActive: true }] },{assignTo:row.username}   ], open: true  }))}>
                    {row.open}</Link>
              ) : row.open
            }
          </>
      ),
    },

    {
      name: "Close",
      selector: "close",
      cell: (row) => (
          <>
            {
              row.username !='Total' ? (
                  <Link to={'/admin/ListProspects?query='+btoa(JSON.stringify({ $and: [ { $or: [{ IsActive: { $exists: false } }, { IsActive: true }] },{assignTo:row.username}   ],open: false  }))}>
                    {row.close}</Link>
              ) : row.close
            }
          </>
      ),
    },
    {
      name: "Upcoming Callbacks",
      selector: "followups",
      cell: (row) => (
          <>
            {
              row.username !='Total' ? (
                  <Link to={'/admin/ListProspects?query='+btoa(JSON.stringify({ IsActive: true,assignTo: row.username,callback: { $gte: new Date() } }  ))}>
                    {row.followups}</Link>
              ) : row.followups
            }
          </>
      ),
    },
    {
      name: "Overdue Callbacks",
      selector: "overdue",
      cell: (row) => (
          <>
            {
              row.username !='Total' ? (
                  <Link to={'/admin/ListProspects?query='+btoa(JSON.stringify({ IsActive: true,assignTo: row.username,callback: { $lt: new Date() } }  ))}>
                    {row.overdue}</Link>
              ) : row.overdue
            }
          </>
      ),
    },


  ];
  useEffect(() => {
    if(user && user.admin) {
      loadWorkloadData();
      loadFavoriteSettings();
      loadFavoriteProspects();
    }
  }, [user]);

  const getColName =(selector)=>{
    for (let index = 0; index < columns.length; index++) {
      const element = columns[index];
      if(element.selector == selector){
        return element.name;
      }
      
    }
  }

  const bindChart = () =>{
    
    let _chartOption = {...chartOption};
    _chartOption.series[0]['data'] = null
    let obj = [];
    for (const key in data.TotalInfo) {
      if (Object.hasOwnProperty.call(data.TotalInfo, key)) {
        const element = data.TotalInfo[key];
        if(!isNaN(element)){
          obj.push({
            "y": element,          
            "name": getColName(key),
            "id": key,
          })
        }
      }
    }
    _chartOption.series[0]['data'] = obj

    return _chartOption;
  }

  
  return (
    <>
      <>
        <Snackbar
          place="tr"
          color={notify.color}
          message={notify.message}
          open={notify.open}
          closeNotification={() => setNotify({ open: false })}
          close
        />


        <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
              title=""
              headerColor="info"
              tabs={[
                ...(enableFavoriteProspects ? [{
                  tabName: "Favorite Prospects",
                  tabContent: (
                      <>
                        <CardHeader color="transparent">
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <h3 style={{ float: "left", margin: 0 }}>
                                Favorite Prospects
                                <span style={{ float: "right", fontSize: "15px" }}>
                                  {["owner", "manager"].indexOf(user && user.role) > -1 && (
                                    <Button
                                      size="sm"
                                      color="transparent"
                                      justIcon
                                      title="Export To Excel"
                                      onClick={() => {
                                        handleExportFavoriteProspects();
                                      }}
                                    >
                                      <GetAppOutlinedIcon />
                                    </Button>
                                  )}
                                </span>
                              </h3>
                              <GridItem style={{float: "right", marginTop: "10px"}}>
                                <InfoBox name={'Report.FavoriteProspects'} />
                              </GridItem>
                            </GridItem>
                          </GridContainer>
                        </CardHeader>
                      <CardBody>
                        {favoriteLoading ? (
                          <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
                        ) : favoriteProspects.length === 0 ? (
                          <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                            No favorite prospects found.
                          </div>
                        ) : (
                          <DataTable
                              columns={favoriteProspectsColumns}
                              data={favoriteProspects || []}
                              highlightOnHover
                              striped
                              dense
                              pagination
                              paginationPerPage={50}
                              paginationRowsPerPageOptions={[10, 25, 50, 100]}
                              customStyles={{
                                table: {
                                  style: {
                                    border: '1px solid #d0d7de',
                                    borderCollapse: 'collapse',
                                  },
                                },
                                header: {
                                  style: {
                                    backgroundColor: '#f3f4f6',
                                    borderBottom: '2px solid #d0d7de',
                                    minHeight: '42px',
                                  },
                                },
                                headRow: {
                                  style: {
                                    backgroundColor: '#f3f4f6',
                                    borderBottom: '2px solid #d0d7de',
                                  },
                                },
                                headCells: {
                                  style: {
                                    borderRight: '1px solid #d0d7de',
                                    paddingLeft: '10px',
                                    paddingRight: '10px',
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    color: '#1f2937',
                                  },
                                },
                                rows: {
                                  style: {
                                    minHeight: '34px',
                                    '&:not(:last-of-type)': {
                                      borderBottom: '1px solid #e5e7eb',
                                    },
                                  },
                                },
                                cells: {
                                  style: {
                                    borderRight: '1px solid #e5e7eb',
                                    paddingLeft: '10px',
                                    paddingRight: '10px',
                                    fontSize: '12px',
                                    color: '#374151',
                                  },
                                },
                                pagination: {
                                  style: {
                                    borderTop: '1px solid #d0d7de',
                                    minHeight: '48px',
                                  },
                                },
                              }}
                          />
                        )}
                      </CardBody>
                  </>
                  ),
                }] : []),
                {
                  tabName: "Basic Report",
                  tabContent: (
                      <>
                        <CardHeader color="transparent">
                          <GridContainer>

                            <GridItem xs={12} sm={12} md={12}>
                            <GridItem  style={{float: "right", marginTop: "10px"}}>
                              <InfoBox name={'Report.BasicReport'} />
                            </GridItem>
                              <GridItem>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={bindChart()}
                                    allowChartUpdate={true}
                                />
                              </GridItem>
                            </GridItem>
                          </GridContainer>
                        </CardHeader>
                      <CardBody>
                        <DataTable
                            columns={columns}
                            data={data.data || []}
                            highlightOnHover
                            striped
                        />
                      </CardBody>
                  </>
                  ),
                },
                {
                  tabName: "Disposition Report",
                  tabContent: (
                      <CardBody>
                        <DispositionDetails
                          user={user}
                          disposition={disposition}
                        />
                      </CardBody>
                  ),
                },
                {
                  tabName: "Monthly Report",
                  tabContent: (
                      <CardBody>
                        <ReportsStats {...props}
                        />
                      </CardBody>
                  ),
                },
              ]}
          />
        </GridItem>



      </>
    </>
  );
}

export default Workload;


